document.addEventListener('DOMContentLoaded', () => {
    const sidebarMenu = document.querySelector('.wcl-docs-page .wcl-sidebar');

    if (sidebarMenu) {
        const trigger = sidebarMenu.querySelector('.wcl-sidebar-menu-trigger');
        const menu = sidebarMenu.querySelector('.menu-list');

        if (!trigger || !menu) return;

        trigger.addEventListener('click', e => {
            e.preventDefault();

            menu.classList.toggle('show');
        })

        document.addEventListener('click', e => {
            if (!sidebarMenu.contains(e.target)) {
                menu.classList.remove('show');
            }
        });
    }
});